'use client';

import cx from 'classnames';
import Image from 'next/image';
import React, { useState, FC } from 'react';

import PartFeatureItem from '@/components/part-feature-item';
import { IAboutUsFeatures } from '@/contentful/utils/aboutUsFeatures';
import { IContentImage } from '@/contentful/utils/contentImage';

import IconLineLeft from './assets/icon-line-left-small.svg';

import styles from './part-features.module.scss';

interface IButton {
  name: string;
  type: string;
}

// TODO: update this interface

interface IFeatures {
  [key: string]: any;
}

interface IFeaturesProps {
  data: {
    category?: string | undefined;
    title?: string | undefined;
    image?: IContentImage | null;
    features: IAboutUsFeatures;
  };
}

const PartFeatures: FC<IFeaturesProps> = ({ data }) => {
  const featuredButton: IButton[] = Array.isArray(data.features.buttons)
    ? data.features.buttons
    : [];

  const [activeButton, setActiveButton] = useState<string>('whyWe');
  const activeFeatures: IFeatures[] = (data.features as Record<string, any>)[activeButton] || [];

  const handleClick = (type: string) => {
    setActiveButton(type);
  };

  return (
    <section className={styles.container}>
      <div>
        <div className={styles.imageWrap}>
          <Image
            src={data.image?.src ?? ''}
            alt={data.image?.alt ?? ''}
            width={data.image?.width ?? 0}
            height={data.image?.height ?? 0}
            className={styles.image}
            quality={75}
          />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.categoryContainer}>
          <IconLineLeft />
          <p className={styles.category}>{data.category}</p>
        </div>
        <h2 className={styles.title}>{data.title}</h2>
        <div className={styles.buttonsContainer}>
          {featuredButton.map((button: IButton) => (
            <button
              className={cx(
                styles.button,
                activeButton === button.type && styles.active,
              )}
              key={button.name}
              type="button"
              onClick={() => handleClick(button.type)}
            >
              <span>{button.name}</span>
            </button>
          ))}
        </div>
        <div className={styles.featureContainer}>
          <ul className={styles.featureList}>
            {activeFeatures?.map((contentItem: IFeatures) => (
              <li key={contentItem.fields.title} className={styles.featureItem}>
                <PartFeatureItem contentItem={contentItem.fields} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default PartFeatures;
